// src/utils/authentication/inviteMessages.js
/**
 * Maps deterministic backend invite-redemption error codes to user-facing
 * translation keys (with English fallbacks).
 *
 * @param {(key: string, fallback?: string) => string} t - i18next translate fn.
 * @param {string|null} code - Backend error code from `inviteErrorCode()`.
 * @returns {string} A user-facing message.
 */
export function inviteErrorMessage(t, code) {
  const map = {
    INVITE_NOT_FOUND: [
      "redeemInvite.errors.notFound",
      "That access code was not recognised. Please check it and try again.",
    ],
    INVITE_ALREADY_USED: [
      "redeemInvite.errors.alreadyUsed",
      "That access code has already been used.",
    ],
    INVITE_EXPIRED: [
      "redeemInvite.errors.expired",
      "That access code has expired. Please request a new invite.",
    ],
    INVITE_EMAIL_MISMATCH: [
      "redeemInvite.errors.emailMismatch",
      "That access code was issued to a different email address.",
    ],
    INVITE_REGION_MISMATCH: [
      "redeemInvite.errors.regionMismatch",
      "That access code is not valid in this region.",
    ],
    INVITE_CODE_REQUIRED: [
      "redeemInvite.errors.required",
      "Please enter your access code.",
    ],
    USER_EMAIL_REQUIRED: [
      "redeemInvite.errors.userEmail",
      "Your account has no email address. Please contact your administrator.",
    ],
  };

  const [key, fallback] = map[code] || [
    "redeemInvite.errors.generic",
    "We couldn’t redeem that access code right now. Please try again.",
  ];

  return t(key, fallback);
}
